export default "__VITE_ASSET__CNDjPoqG__"